import '../collection/collection.css'
import Collection_1 from '../../img/Collection_1.jpg'
import Collection_2 from '../../img/Collection_2.jpg'
import Collection_3 from '../../img/Collection_3.jpg'
import Collection_4 from '../../img/Collection_4.jpg'
import Collection_5 from '../../img/Collection_5.jpg'
import Collection_6 from '../../img/Collection_6.jpg'
import Collection_7 from '../../img/Collection_7.jpg'
import Collection_8 from '../../img/Collection_8.jpg'
import Collection_9 from '../../img/Collection_9.jpg'
import Collection_10 from '../../img/Collection_10.jpg'
import Collection_11 from '../../img/Collection_11.jpg'
import Collection_12 from '../../img/Collection_12.jpg'
import Collection_13 from '../../img/Collection_13.jpg'
import Collection_14 from '../../img/Collection_14.jpg'
import Collection_15 from '../../img/Collection_15.jpg'
import Collection_16 from '../../img/Collection_16.jpg'
import Collection_17 from '../../img/Collection_17.jpg'
import Collection_18 from '../../img/Collection_18.jpg'
import {Link} from "react-router-dom";
const {Fragment} = require("react");



function Collection() {
    return (
        <Fragment>
            <section className="S1_Collection">
<div className="container">

                    <h1>COLLECTION</h1>

                    <ul>
                    <li>  <Link to="/">home</Link>  </li>
                    <li>  /  </li>
                    <li>  <Link to="/COLLECTION">COLLECTION</Link>  </li>

                    </ul>

                 </div>

            </section>


            <section className="S2_collection">
                <div className='container'>
                    <div className='intro'>
                        <h3>all items</h3>
                        <div className="line"><span></span></div>
                    </div>
                <div className='row'>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_1} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_2} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>                       

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_3} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_4} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_5} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>


                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_6} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>


                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_7} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>


                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_8} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_9} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_10} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_11} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_12} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_13} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_14} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_15} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_16} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_17} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>

                         <div className='col-lg-3 col-md-6'>
                            <div className='card'>
                                <img src={Collection_18} alt='sora' />
                                <span>Neoh #4588</span>
                            </div>
                        </div>                       



                </div>
                </div>


            </section>
        </Fragment>
    )
}
export default Collection